import {
  Component, OnDestroy, OnInit, forwardRef,
  DoCheck, Input, Output, EventEmitter
} from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
@Component({
  selector: 'sender-qualification-pre-stage',
  templateUrl: './sender-qualification-pre-stage.component.html',

  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class SenderQualificationPreStageComponent implements OnInit, OnDestroy {


  @Input() model: models.SenderQualificationVM;
  @Input() isLegalRepresentationEnabled: boolean;

  isVisibleIsBeneficiary: boolean = false;
  isVisibleIsLegalRepresentative: boolean = false;

  ngOnInit(): void {
    if (this.model.isBeneficiary !== null && this.model.isBeneficiary !== undefined) {
      if (this.model.isBeneficiary?.toString() === 'true') {
        this.model.isBeneficiary = true;
      } else {
        this.model.isBeneficiary = false;
      }
      if (this.model.isLegalRepresentative?.toString() === 'true') {
        this.model.isLegalRepresentative = true;
      } else {
        this.model.isLegalRepresentative = false;
      }
    }
  }

  ngOnDestroy(): void {
    }

  public isBeneficiaryChanged(value: boolean) {
    this.model.isBeneficiary = value;
  }

  public isLegalRepresentativeChanged(value: boolean) {
    this.model.isLegalRepresentative = value;
  }

  public toggleVisibilityIsBeneficiary() {
    this.isVisibleIsBeneficiary = !this.isVisibleIsBeneficiary;
  }

  public toggleVisibilityIsLegalRepresentative() {
    this.isVisibleIsLegalRepresentative = !this.isVisibleIsLegalRepresentative;
  }
}
